import { Help } from '@components/types/help/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface HelpsState {
  list: Help[],
  loading: boolean,
  error: string | null,
}

const initialState: HelpsState = {
  list: [],
  loading: false,
  error: null,
}

const helpSlice = createSlice({
  name: 'help',
  initialState,
  reducers: {
    createHelp(state, action: PayloadAction<Help>) {
      state.list.push(action.payload);
      state.loading = false;
      state.error = null;
    },
    updateHelp(state, action: PayloadAction<Help>) {
      const { _id } = action.payload;
      const helpIndex = state.list.findIndex(help => help._id === _id);
      if (helpIndex > 0) {
        state.list[helpIndex] = action.payload;
        state.loading = false;
        state.error = null;
      }
    },
    deleteHelp(state, action: PayloadAction<{ _id: string }>) {
      const { _id } = action.payload;
      state.list = state.list.filter(help => help._id !== _id);
      state.loading = false;
      state.error = null;
    },
    fetchHelps(state, action: PayloadAction<Help[]>) {
      state.list = action.payload;
      state.loading = false;
      state.error = null;
    },
    helpsStart(state) {
      state.loading = true;
      state.error = null;
    },
    helpsError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  createHelp,
  updateHelp,
  deleteHelp,
  fetchHelps,
  helpsStart,
  helpsError,
} = helpSlice.actions;

export default helpSlice.reducer;
